// extracted by mini-css-extract-plugin
module.exports = {"links":"LinkList_links__hRaQH","link":"LinkList_link__ws3u5"};